import { apiMessages } from "./apiMessages";

const escape = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// Templates are maintained catalog keys, never regular expressions supplied by
// a server response. Bound length/placeholder count to keep matching predictable.
const templates = Object.entries(apiMessages).sort(([a], [b]) => b.replace(/\{\w+\}/g, "").length - a.replace(/\{\w+\}/g, "").length).flatMap(([source, translated]) => {
  const keys = [...source.matchAll(/\{(\w+)\}/g)].map(match => match[1]!);
  if (!keys.length || keys.length > 6) return [];
  const parts = source.split(/\{\w+\}/g).map(escape);
  return [{keys, translated, pattern: new RegExp("^" + parts.join("([\\s\\S]{0,512}?)") + "$")}];
});

/** Localize only system errors; interpolated names and values remain verbatim. */
export function formatApiMessage(message: string, language: "en" | "es"): string {
  if (language !== "es") return message;
  if (apiMessages[message]) return apiMessages[message]!;
  if (message.startsWith("Not permitted: ")) return "No permitido: " + formatApiMessage(message.slice(15),language);
  if (message.length <= 3000) for (const template of templates) {
    const match = template.pattern.exec(message);
    if (!match) continue;
    const values = Object.fromEntries(template.keys.map((key,index) => [key,match[index+1]!]));
    return template.translated.replace(/\{(\w+)\}/g,(full,key:string) => values[key] ?? full);
  }
  // Validation arrays are assembled by the API client, not arbitrary prose.
  if (message.includes("; ")) return message.split("; ").map(part => formatApiMessage(part,language)).join("; ");
  return message;
}
